//cart counter start
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var blockCounter = document.querySelector('#cart_counter'); 
      // If the cart count is 0, hide the block
      if (cart.item_count === 0) {
        blockCounter.style.display = 'none';
      } else {
        blockCounter.textContent = cart.item_count;
        blockCounter.style.display = 'block';
      }
    });
}
//cart counter end
//mobile menu opener start
const mobMenuFirstLvl = document.querySelectorAll(".header-menu-button");
mobMenuFirstLvl.forEach((mobMenuFirstLvlElem) => {
    mobMenuFirstLvlElem.onclick = function (e) {        
        e.preventDefault();
        let mobMenu = document.querySelector('.mobile-menu');
        document.getElementById("trelo-basket").classList.remove('show');
        document.getElementById('header-search').classList.remove("show");
        mobMenu.classList.toggle("is-open");
   };
});

//mobile menu opener end

//mobile menu 2 lvl start
const mobMenuScndLvlOpen = document.querySelectorAll(".mobile-menu-main-item__has-child .mobile-menu-main-item-link");

mobMenuScndLvlOpen.forEach((mobMenuScndLvlOpenElem) => {
    mobMenuScndLvlOpenElem.onclick = function (e) {        
        e.preventDefault();
        let parent = e.target.closest('.mobile-menu-main-item__has-child');
        parent.classList.toggle("is-open")
   };
});

const mobMenuScndLvlClose = document.querySelectorAll(".mobile-menu-main-item__child-item-link-back");

mobMenuScndLvlClose.forEach((mobMenuScndLvlCloseElem) => {
    mobMenuScndLvlCloseElem.onclick = function (e) {        
        e.preventDefault();
        let parent = e.target.closest('.mobile-menu-main-item__has-child');
        parent.classList.toggle("is-open")
   };
});
//mobile menu 2 lvl end

//mobile menu accordion start
const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function (e) {
    e.preventDefault();
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    //console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      //console.log(content.style.maxHeight);
    }
  };
});
//mobile menu accordion end

//footer menu accordion start
const accordionBtnsF = document.querySelectorAll(".accordion-footer");

accordionBtnsF.forEach((accordionF) => {
  accordionF.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    //console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      //console.log(content.style.maxHeight);
    }
  };
});
//footer menu accordion end

//fixed header start
//transparent header init
(function () {
  const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
  if (!firstSection) return;
  const marker = firstSection.querySelector('[data-transparent-header]');
  if (!marker) return;
  document.body.classList.add('transparent-header');
  if (marker.getAttribute('data-transparent-header') === 'frosted') {
    document.body.classList.add('header-frosted');
  }
})();

window.addEventListener('scroll', function() {
    const header = document.querySelector('.header-holder');
    if (!header) return;
    const body = document.querySelector('body');
    const announcementEl = document.querySelector('.announcement-bar');
    const announcement = announcementEl ? announcementEl.offsetHeight : 0;

    if (window.scrollY > announcement) {
        header.classList.add('fixed');
        if (!body.classList.contains('transparent-header')) {
            body.classList.add('headerfixed');
        }
    } else {
        header.classList.remove('fixed');
        body.classList.remove('headerfixed');
    }
});
//fixed header end

// basket opener start
var pbasket = document.getElementById("trelo-basket");
const pbasket2 = document.getElementById("trelo-basket-drawer__wrapper");
const body2 = document.querySelector('body');

function hasClass(element, className) {
  return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

function OpenCloseBasket() {
  document.querySelector('.mobile-menu').classList.remove("is-open");
  document.getElementById('header-search').classList.remove("show");
  pbasket.classList.toggle('show');
  body2.classList.toggle('basketopened');  
}

// just basket open start
function OpenBasket() {
  pbasket.classList.toggle('show');
}
// just basket open end
// basket opener end

//PRODUCT ADD TO CART JS START

//recomended start
function addRecomendedProduct(variantId, variantQuantity) {
  addItem(variantId, variantQuantity);  
  setTimeout(() => {
    document.getElementById("trelo-basket-drawer__recomended").style.display = "none";
  }, "1000");  
}
//recomended end

//insert to THML dom
function setInnerHTML(elm, html) {
  elm.innerHTML = html;

  Array.from(elm.querySelectorAll('script')).forEach((oldScriptEl) => {
    const newScriptEl = document.createElement('script');

    Array.from(oldScriptEl.attributes).forEach((attr) => {
      newScriptEl.setAttribute(attr.name, attr.value);
    });

    const scriptText = document.createTextNode(oldScriptEl.innerHTML);
    newScriptEl.appendChild(scriptText);

    oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
  });
}
//insert to THML dom end

//section rendering
window.renderCart = function () {
  fetch(`/?sections=${document.getElementById('trelo-basket').getAttribute('section-id')}`)
    .then((response) => response.json())
    .then((json) => {
      let html = json[document.getElementById('trelo-basket').getAttribute('section-id')];
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');
      let newCheckout = doc.getElementById('trelo-basket-drawer__wrapper');
      let newCheckoutHtml = newCheckout.outerHTML;
      setInnerHTML(document.getElementById('trelo-basket-drawer__block'), newCheckoutHtml);
      
      if(hasClass(body2, 'basketopened')) {
      } else {
      	body2.classList.add('basketopened');
      }
    })
    .catch((error) => {
      // Handle errors
      console.error('Error rendering section:', error);
    });
};
//section rendering end

// Remove and Update item
function removeItem(variantId, variantQuantity, outOfStuck) {
  if (outOfStuck >= variantQuantity) {
    variantQuantity = variantQuantity;
  } else {
    variantQuantity = 0;
  }   
    
  fetch(`/cart/change.js?id=${variantId}&quantity=${variantQuantity}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest', // For Shopify AJAX API
    },
  })
  .then(response => response.json())
  .then(data => {
    // Update the cart quantity display
    window.renderCart();
 // Update the cart count
    updateCartCount();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });    
}
// Remove and Update item end

// Add item
function addItem(variantId, variantQuantity, varProp) {
  var properties = {
    '': '',
  };
  if (varProp != ''){
    properties = {
      'PRE ORDER': varProp,
    };
  }
    
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: variantQuantity,
      properties: properties,
      
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log('Success:', data);
      window.renderCart();   
       // Update the cart count
    updateCartCount();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
// Add item End
//PRODUCT ADD TO CART JS END

//HEADER SEARCH START
//search opener start
function showHeaderSearch() {
  const headerSearchShow = document.getElementById('header-search');
  document.querySelector('.mobile-menu').classList.remove("is-open");
  document.getElementById("trelo-basket").classList.remove('show')
  headerSearchShow.classList.toggle("show");
}
//search opener end

//search fast result start
const searchForm = document.getElementById('header-search__form');
const searchInput = document.getElementById('header-search__form-input');
const searchResults = document.getElementById('header-search__result-list');
const searchResultsTop = document.getElementById('header-search__result-top');
const searchResultsTopLink = document.getElementById('header-search__result-top-link');
const searchResultsEmpty = document.getElementById('header-search__result-list-empty');
const toolprdidSearch = searchResults.dataset.toolprdidsearch;
const saleCollectionHandle = 'sale';

// Event listener for user input in the search form
searchInput.addEventListener('input', function () {
  const query = searchInput.value.trim();
  const discountenable = searchInput.dataset.discountenable;
  const discountnumber = searchInput.dataset.discountnumber;
  productHeaderSearch(query,discountenable,discountnumber);
});

function productHeaderSearch(query,discountenable,discountnumber) {
  var searchCountItem = 1;

  // If the search query is not empty, send a request to Shopify API
  if (query !== '') {   
  
    fetch(`/search/suggest.json?q=${query}&type=product&options[unavailable_products]=hide`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        // Process and display the search results
        if (data && data.resources.results.products.length > 0) {
          // Clear previous search results
          searchResults.innerHTML = '';
          searchResultsEmpty.style.display = "none";
          searchResultsTop.style.display = "block";
          searchResults.style.display = "flex";
          searchResultsTopLink.setAttribute('href', '/search?q='+query+'*&type=product');
          
          let searchHeaderLngt = 0;
          
          if(data.resources.results.products.length == 1){
            data.resources.results.products.forEach(product => {
              if (product.id == toolprdidSearch ) searchHeaderLngt = product.id;
            });
          }           

          data.resources.results.products.forEach(product => {
            if (searchHeaderLngt == 0) {
              if (searchCountItem < 5){
                if (product.id != toolprdidSearch ){

                  // Fetch all products in the collection for price start
                  let saleCollectionHandleExist = 0;
                  let productId = product.id;                  
                  fetch(`/collections/${saleCollectionHandle}/products.json`)
                    .then(response => {
                      if (!response.ok) {
                        throw new Error(`Error: ${response.status} ${response.statusText}`);
                      }
                      return response.json();
                    })
                    .then(data => {
                      const products = data.products;
                      // Check if the product ID exists in the collection
                      const productExists = products.some(product => product.id === productId);
                
                      if (productExists) {
                        let saleCollectionHandleExist = 1;
                      } else {
                        let saleCollectionHandleExist = 0;
                      }
                    })
                    .catch(error => console.error('Error fetching collection products:', error));
                  
                  //console.log('saleCollectionHandleExist - '+saleCollectionHandleExist);
                  //console.log(discountenable);
                  //console.log(discountnumber);
                  //console.log(product);
                  // Fetch all products in the collection for price end                  
                  
                  const productLink = document.createElement('a');
                  productLink.setAttribute('class', 'header-search__list-item');
                  productLink.setAttribute('href', product.url);
    
                  const productLinkImage = document.createElement('picture');
                  productLinkImage.setAttribute('class', 'header-search__list-item-img');
    
                  const productLinkImageSource1 = document.createElement('source');
                  productLinkImageSource1.setAttribute('media', '(min-width:2500px)');
                  productLinkImageSource1.setAttribute('srcset', product.featured_image.url+'&width=2560');
    
                  const productLinkImageSource2 = document.createElement('source');
                  productLinkImageSource2.setAttribute('media', '(min-width:1900px)');
                  productLinkImageSource2.setAttribute('srcset', product.featured_image.url+'&width=1900');
    
                  const productLinkImageSource3 = document.createElement('source');
                  productLinkImageSource3.setAttribute('media', '(min-width:1400px)');
                  productLinkImageSource3.setAttribute('srcset', product.featured_image.url+'&width=1400');
    
                  const productLinkImageSource4 = document.createElement('source');
                  productLinkImageSource4.setAttribute('media', '(min-width:1200px)');
                  productLinkImageSource4.setAttribute('srcset', product.featured_image.url+'&width=1200');
    
                  const productLinkImageSource5 = document.createElement('source');
                  productLinkImageSource5.setAttribute('media', '(min-width:900px)');
                  productLinkImageSource5.setAttribute('srcset', product.featured_image.url+'&width=900');
    
                  const productLinkImageSource6 = document.createElement('source');
                  productLinkImageSource6.setAttribute('media', '(min-width:800px)');
                  productLinkImageSource6.setAttribute('srcset', product.featured_image.url+'&width=800');
    
                  const productLinkImageSource7 = document.createElement('source');
                  productLinkImageSource7.setAttribute('media', '(min-width:400px)');
                  productLinkImageSource7.setAttribute('srcset', product.featured_image.url+'&width=800');
    
                  const productLinkImageSource8 = document.createElement('source');
                  productLinkImageSource8.setAttribute('media', '(min-width:300px)');
                  productLinkImageSource8.setAttribute('srcset', product.featured_image.url+'&width=600');
    
                  const productLinkImageImg = document.createElement('img');
                  productLinkImageImg.setAttribute('src', product.featured_image.url+'&width=600');
                  productLinkImageImg.setAttribute('width', product.featured_image.width);
                  productLinkImageImg.setAttribute('height', product.featured_image.height);
                  productLinkImageImg.setAttribute('loading', 'lazy');
                  productLinkImageImg.setAttribute('alt', product.featured_image.alt);
    
                  const productLinkText = document.createElement('div');
                  productLinkText.setAttribute('class', 'header-search__list-item-text');
    
                  const productLinkTitle = document.createElement('div');
                  productLinkTitle.setAttribute('class', 'header-search__list-item-title');
                  productLinkTitle.textContent = product.title;

                  const productLinkPrice = document.createElement('div');
                  if (saleCollectionHandleExist == 1) {
                    if (product.compare_at_price_max > product.price ){                      
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price header-search__list-item-price-comp');
                      const productLinkPriceNEW = document.createElement('span');
                      productLinkPriceNEW.setAttribute('class', 'new');
                      productLinkPriceNEW.textContent = product.price+" "+custCurrentCurrency;
                      productLinkPrice.appendChild(productLinkPriceNEW);
                      const productLinkPriceOld = document.createElement('span');                      
                      productLinkPriceOld.setAttribute('class', 'old');
                      productLinkPriceOld.textContent = product.compare_at_price_max+" "+custCurrentCurrency;
                      productLinkPrice.appendChild(productLinkPriceOld);
                    } else {
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price');
                      productLinkPrice.textContent = product.price+" "+custCurrentCurrency;
                    }
                  } else if (discountenable == 1) {
                      let newPrice = product.price * discountnumber;
                      newPrice = newPrice.toFixed(2);
                    
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price header-search__list-item-price-comp');
                    
                      const productLinkPriceNEW = document.createElement('span');
                      productLinkPriceNEW.setAttribute('class', 'new');
                      productLinkPriceNEW.textContent = newPrice+" "+custCurrentCurrency;
                      productLinkPrice.appendChild(productLinkPriceNEW);
                    
                      const productLinkPriceOld = document.createElement('span');                                          
                      productLinkPriceOld.setAttribute('class', 'old');
                      productLinkPriceOld.textContent = product.price+" "+custCurrentCurrency;
                      productLinkPrice.appendChild(productLinkPriceOld);
                  } else {
                    if (product.compare_at_price_max > product.price ){
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price header-search__list-item-price-comp');
                      const productLinkPriceNEW = document.createElement('span');
                      productLinkPriceNEW.setAttribute('class', 'new');
                      productLinkPriceNEW.textContent = product.price+" "+custCurrentCurrency;                      
                      productLinkPrice.appendChild(productLinkPriceNEW);
                      const productLinkPriceOld = document.createElement('span');
                      productLinkPriceOld.setAttribute('class', 'old');
                      productLinkPriceOld.textContent = product.compare_at_price_max+" "+custCurrentCurrency;
                      productLinkPrice.appendChild(productLinkPriceOld);
                    } else {
                      productLinkPrice.setAttribute('class', 'header-search__list-item-price');
                      productLinkPrice.textContent = product.price+" "+custCurrentCurrency;
                    }
                  }
   
                  productLinkImage.appendChild(productLinkImageSource1);
                  productLinkImage.appendChild(productLinkImageSource2);
                  productLinkImage.appendChild(productLinkImageSource3);
                  productLinkImage.appendChild(productLinkImageSource4);
                  productLinkImage.appendChild(productLinkImageSource5);
                  productLinkImage.appendChild(productLinkImageSource6);
                  productLinkImage.appendChild(productLinkImageSource7);
                  productLinkImage.appendChild(productLinkImageSource8);
                  productLinkImage.appendChild(productLinkImageImg);
    
                  productLinkText.appendChild(productLinkTitle);
                  productLinkText.appendChild(productLinkPrice);
    
                  productLink.appendChild(productLinkImage);
                  productLink.appendChild(productLinkText);
                  
                  searchResults.appendChild(productLink);
                  searchCountItem++;
                }
              }
            } else {
              // Clear previous search results
              searchResults.innerHTML = '';
              // Display a message for no results
              searchResultsTop.style.display = "none";
              searchResults.style.display = "none";
              searchResultsEmpty.style.display = "block";
            }
          });
        } else {
          // Clear previous search results
          searchResults.innerHTML = '';
          // Display a message for no results
          searchResultsTop.style.display = "none";
          searchResults.style.display = "none";
          searchResultsEmpty.style.display = "block";
        }
      })
      .catch(error => {
        console.error('Error fetching search results:', error);
      });      
  } else {
    searchResults.innerHTML = '';
    searchResultsTop.style.display = "none";
    searchResults.style.display = "none";
    searchResultsEmpty.style.display = "block";
  }
}
//search fast result end
//HEADER SEARCH END
/* ============================================================
   TASK 5: CARD GALLERY + MOBILE QUICK ADD START
   Paste this block at the END of assets/all.js.
   All handlers are delegated on document, so cards appended by
   the PLP infinite scroll and cards inside Swiper sections work
   without re-initialization.
   ============================================================ */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 767px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getGallery(el) {
    if (!el || !(el instanceof Element)) return null;
    return el.closest('[data-card-gallery]');
  }

  function getTrack(gallery) {
    return gallery.querySelector('[data-card-track]');
  }

  function slideCount(gallery) {
    return parseInt(gallery.getAttribute('data-slide-count'), 10) || 1;
  }

  function storedIndex(gallery) {
    return parseInt(gallery.getAttribute('data-index'), 10) || 0;
  }

  // Un-lazy the target slide and its neighbors so navigation never shows a blank frame
  function eagerLoad(gallery, index) {
    var imgs = gallery.querySelectorAll('.product-item-slide img');
    [index - 1, index, index + 1].forEach(function (i) {
      var img = imgs[i];
      if (img && img.getAttribute('loading') === 'lazy') img.removeAttribute('loading');
    });
  }

  function goTo(gallery, index, instant) {
    var track = getTrack(gallery);
    if (!track) return;
    var count = slideCount(gallery);
    if (index < 0) index = count - 1; // wrap
    if (index > count - 1) index = 0;
    eagerLoad(gallery, index);
    gallery.setAttribute('data-index', index);
    // Use the slide's exact fractional position. offsetLeft is rounded to an
    // integer while flex slide boundaries can be fractional, and programmatic
    // jumps are not re-snapped by the browser, so integer targets leave a
    // subpixel sliver of the neighboring slide visible.
    var slide = track.querySelectorAll('.product-item-slide')[index];
    var target = index * track.clientWidth;
    if (slide) {
      target = track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
    }
    track.scrollTo({
      left: target,
      behavior: (instant || REDUCED.matches) ? 'auto' : 'smooth'
    });
  }

  // ---- Arrows + quick add (delegated clicks) ----
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var prev = e.target.closest('[data-card-prev]');
    var next = e.target.closest('[data-card-next]');
    var qa = e.target.closest('[data-quick-add]');
    if (!prev && !next && !qa) return;

    e.preventDefault();
    e.stopPropagation();

    var gallery = getGallery(e.target);

    if (prev || next) {
      if (!gallery) return;
      // Arrow use makes the chosen view sticky: hover preview stops interfering
      gallery.setAttribute('data-actioned', '');
      goTo(gallery, storedIndex(gallery) + (next ? 1 : -1));
      return;
    }

    // Quick add
    if (qa.hasAttribute('data-busy')) return;
    if (typeof addItem !== 'function') return;
    qa.setAttribute('data-busy', '');
    var variantId = parseInt(qa.getAttribute('data-variant-id'), 10);
    var preorderProp = qa.getAttribute('data-preorder') || '';
    addItem(variantId, 1, preorderProp);
    if (typeof OpenBasket === 'function') OpenBasket();
    qa.setAttribute('data-added', '');
    setTimeout(function () {
      qa.removeAttribute('data-added');
      qa.removeAttribute('data-busy');
    }, 1600);
  });

  // ---- Desktop hover preview (slide 2), sticky after arrow use ----
  document.addEventListener('pointerover', function (e) {
    if (!DESKTOP.matches || e.pointerType === 'touch') return;
    if (!(e.target instanceof Element)) return;
    var card = e.target.closest('.product-item');
    if (!card || (e.relatedTarget instanceof Element && card.contains(e.relatedTarget))) return;
    var gallery = card.querySelector('[data-card-gallery]');
    if (!gallery || slideCount(gallery) < 2) return;
    if (gallery.hasAttribute('data-actioned')) return;
    goTo(gallery, 1, true);
  });

  document.addEventListener('pointerout', function (e) {
    if (!DESKTOP.matches || e.pointerType === 'touch') return;
    if (!(e.target instanceof Element)) return;
    var card = e.target.closest('.product-item');
    if (!card || (e.relatedTarget instanceof Element && card.contains(e.relatedTarget))) return;
    var gallery = card.querySelector('[data-card-gallery]');
    if (!gallery || gallery.hasAttribute('data-actioned')) return;
    goTo(gallery, 0, true);
  });

  // ---- Mobile: track native swipe position (scroll events captured at document) ----
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.hasAttribute('data-card-track')) return;
    var gallery = t.closest('[data-card-gallery]');
    if (!gallery || !t.clientWidth) return;
    gallery.setAttribute('data-index', Math.round(t.scrollLeft / t.clientWidth));
  }, true);

  // ---- Mobile: pre-load neighbor images on first touch of a gallery ----
  document.addEventListener('touchstart', function (e) {
    var gallery = getGallery(e.target);
    if (gallery) eagerLoad(gallery, storedIndex(gallery));
  }, { passive: true });

  // ---- Keep the shown slide aligned after resize/orientation change ----
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-card-gallery]').forEach(function (gallery) {
        goTo(gallery, storedIndex(gallery), true);
      });
    }, 150);
  });
})();
/* ============================================================
   TASK 5: CARD GALLERY + MOBILE QUICK ADD END
   ============================================================ */